// a library to wrap and simplify api calls
import Api from './PhiApi'

export default class PhiMetadata {

    constructor(options) {
        this.phiRef = options

        this.getGlossary = function* (that) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getGlossary();
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }
        

        this.getMetaData = function* (that, options) {
          const { metaType, config } = options
          let response, headerconfig
          
          let token = that.phiRef.getSession()
          if (token) {
            if (metaType === 'zones') {
              headerconfig = config || {}
              response = yield Api.getZones(headerconfig)
            }
            else if (metaType === 'city') {
              headerconfig = config || {stateId: 2}
              response = yield Api.getCity(headerconfig)
            }
            else if (metaType === 'district') {
              headerconfig = config || {}
              response = yield Api.getDistrict(headerconfig)
            }
            else if (metaType === 'state') {
              headerconfig = config || {countryId: 1}
              response = yield Api.getStates(headerconfig)
            }
            else if (metaType === 'country') {
              response = yield Api.getCountry()
            }
            else if (metaType === 'partners') {
              response = yield Api.getPartners()
            }
            else if (metaType === 'specialities') {
              response = yield Api.getSpecialities()
            }
            else if (metaType === 'offers') {
              response = yield Api.getOffers()
            }


            if (response && response.ok && response.data && response.data.results && response.data.results.length > 0) {
              let metadata = response.data.results;

              if(metaType === 'partners') {
                metadata = metadata[0].partners_json;

                try {
                  metadata = JSON.parse(metadata);

                  const result = [];

                  metadata.forEach((item, pos) => {
                    if(item.json_value === null) {
                      result.push(item);
                    }
                    else if(item.json_value.type === 'vendorLogo' &&
                    !Boolean(result.find((checkItem) => item.id === checkItem.id))) {
                      result.push(item);
                    }
                  });

                  return result;
                }
                catch(e) {
                  console.log(e);
                }

                return { error: 'Failed to fetch Partners' }
              }

              if(metaType === 'offers') {
                metadata = metadata[0].offers_json;

                try {
                  metadata = JSON.parse(metadata);
                  return metadata;
                }
                catch(e) {
                  console.log(e);
                }

                return { error: 'Failed to fetch Offers' }
              }

              return metadata.map((a) => a)
            }
            else {
                return { error: response.problem || 'Failed to fetch info' }
            }
          }            
        }
    }


}